// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

(function(){

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		//is explorer
		function msieversion() {

			var ua = window.navigator.userAgent;
			var msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}

			return false;
		}

		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
		var scrollParallax = []
		var scrolled = 0

		// screen height
		var v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") // get it from html
			//get distance in positive value
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				//get distance in negative value (to do the scroll inverse)
				distance = distance * -1
			}
			//Equivalent distance using screen height + element height
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				//Obtain the distance between top screen and document top 0
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				//Distance of bottom page to top of the element
				let relative_distance = scrolled + v_height - topElement
				//transpoling data to move the parallax element relative to the scroll of all the screen
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, // relative to document viewport
				rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				threshold: 0 // visible amount of item shown in relation to root
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	$(".form-module-wrapper form").addClass('animate-fade top');
	$(".text-modules-wrapper .text-modules").addClass('animate-fade top');

	let BurgerMenu = document.getElementById('js_btn_menu');
	let NavigationBox = document.getElementById('navigationBox');
	let CloseMenu = document.getElementById('close_menu');
	let Body = document.body;

	if(NavigationBox){
		BurgerMenu.addEventListener('click', function(e){
			e.preventDefault();
			NavigationBox.classList.add('open');
			Body.classList.add('scroll-no');
		});
		CloseMenu.addEventListener('click', function(e){
			e.preventDefault();
			NavigationBox.classList.remove('open');
			Body.classList.remove('scroll-no');
		});
		$(document).on('keydown', function (e) {
			if (e.keyCode === 27) { // ESC
				NavigationBox.classList.remove('open');
				BookingBox.classList.remove('open');
				Body.classList.remove('scroll-no');
			}
		});
	}

	let BookingBox = document.getElementById('bookingBox');
	let BtnReserve = document.getElementById('js_btn_book');
	let BtnClose = document.getElementById('btn-close');

	if(BookingBox){
		BtnReserve.addEventListener('click', function(e){
			e.preventDefault();
			BookingBox.classList.add('open');
			document.body.classList.add('scroll-no');
		});
		BtnClose.addEventListener('click', function(e){
			e.preventDefault();
			BookingBox.classList.remove('open');
			document.body.classList.remove('scroll-no');
		});
	}

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//To create after event
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		};
		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		});
		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		});

		$('.calendar-block').datepicker({
			changeMonth: false,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 2,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					$('#fakeInput').fadeOut();
					opencheck = 1;
					firstClick = 0;
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
				$('#arrive_depart').attr('value', start + ' - ' + end);

			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});


		// Calendar home fixed
		$('#arriveInput_home').on('change', function(){
			start = $(this).val();
			$('.calendar-block-home').datepicker("setDate", start)
		});
		$('#departureInput_home').on('change', function(){
			end = $(this).val();
			$('.calendar-block-home').datepicker("setDate", end)
		});

		$('#arrive_depart_home').datepicker({
			changeMonth: false,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 1,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					$('#fakeInput').fadeOut();
					opencheck = 1;
					firstClick = 0;
				}

				$('#arriveInput_home').attr('value', start);
				$('#departureInput_home').attr('value', end);
				$('#arrive_depart_home').attr('value', start + ' - ' + end);
				$('#arrive_depart_home').val(start + ' - ' + end);

			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});

		

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	let screenHeight = $(window).height();
	$('#home .top-img figure, #home .top-img video').css("height", screenHeight);

	$(window).resize(function(){
		screenHeight = $(window).height();
		$('#home .top-img figure, #home .top-img video').css("height", screenHeight);
	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());
// lenguage btn
// function convertBtn() {
// 	if (document.getElementsByClassName('btn').length > 0) {
// 		let ALL_BTNS = document.querySelectorAll('.btn');
// 		ALL_BTNS.forEach((btn) => {
// 			if (btn.getAttribute('type') !== 'submit') {
// 				let INNER_TEXT = btn.innerHTML;
// 				btn.innerHTML = '<span>' + INNER_TEXT + '</span>';
// 			}
// 		});
// 	}

// 	$('.header__lang-active').click(function (e) {
// 		e.preventDefault();
// 		$('.header__lang-select').toggleClass('open');
// 	});
// };
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
		let btnActive = document.querySelector('.header__lang-active');
        let btnInactive = document.querySelector('.header__lang-select');

         btnActive.addEventListener('click', (e)=>{
            e.preventDefault();
            btnInactive.classList.toggle('hidden')
         });